class TableCellController {
    row;
    column;

    iconName;
    iconColor;
    iconTooltip;
    textColor;
    cellClass;
    constructor(private $scope){}
    $onInit: Function = (()=>{
        this.$scope.row = this.row;
        this.$scope.$watch('row', ()=>{
            if(this.column.icon){
                this.setIcon();
            }
            else {
                this.setTextColor();
            }
            if(this.column.cellClass){
                this.setCellClass();
            }
        }, true);
    });


    setIcon(){
        this.setIconName();
        this.setIconColor();
        this.setIconTooltip();
    }
    callCellFunction(event){
        if(this.column.cellFunction){
            this.column.cellFunction(event, this.row)
        }
    }
    setIconName(){
        if(this.column.icon.name){
            this.iconName =  typeof(this.column.icon.name) === "string" ? this.column.icon.name : this.column.icon.name(this.row);
        }
    }
    setIconColor(){
        if(this.column.icon.color){
            this.iconColor = typeof(this.column.icon.color) === "string" ? this.column.icon.color : this.column.icon.color(this.row)
        }
    }
    setIconTooltip(){
        if(this.column.icon.tooltip){
            this.iconTooltip =  typeof(this.column.icon.tooltip) === "string" ? this.column.icon.tooltip : this.column.icon.tooltip(this.row);
        }
    }
    setTextColor(){
        if(this.column.color){
            this.textColor =  typeof(this.column.color) === "string" ? this.column.color : this.column.color(this.row);
        }
    }
    setCellClass(){
        if(this.column.cellClass){
            this.cellClass =  typeof(this.column.cellClass) === "string" ? this.column.cellClass : this.column.cellClass(this.row);
        }
    }
    callIconFunc(event){
        if(this.column.icon.functionCall){
            event.stopPropagation();
            this.column.icon.functionCall(event,this.row)
        }
    }
}

class TableCellOptions implements ng.IComponentOptions {
    bindings: any = {
        row: '=',
        column: '='
    };
    controller: string = 'ccTableCellController';
    controllerAs:string = 'c';
    template: any = require('./tableCell.html');
}

rkcApp.controller("ccTableCellController", ['$scope', function($scope){
    return new TableCellController($scope);
}])
    .component("ccTableCell", new TableCellOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/table/tableCell/tableCell.ts
 **/